import * as yup from 'yup';

export const changeCredentialFormSchema = yup.object().shape({
  origin: yup.string().required('É necessário informar a origem.'),
  destiny: yup.string().required('É necessário informar um destino.'),
});
